import { ConversationListItemResponse } from "@redotech/effect-api-shared/models/shopper-ai/conversation/conversation";
import {
  EnhancedDataTable,
  EnhancedDataTableSearch,
  EnhancedDataTableToolbar,
  EnhancedDataTableViewOptions,
} from "@redotech/redo-web/components/ui/enhanced-data-table";
import { memo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useConversationsTable } from "../hooks/use-conversations-table";

export const ConversationsTable = memo(function ConversationsTable({
  maxHeight = "calc(100vh - 200px)",
}: {
  maxHeight?: string;
}) {
  const navigate = useNavigate();
  const { teamId } = useParams<{ teamId: string }>();

  const { table, hasNextPage, isFetchingNextPage, fetchNextPage } =
    useConversationsTable();

  const handleRowClick = ({ row }: { row: ConversationListItemResponse }) => {
    if (teamId) {
      navigate(`/stores/${teamId}/support-v2/${row.id}`);
    }
  };

  return (
    <EnhancedDataTable
      enableInfiniteScroll
      hasMore={hasNextPage}
      loadingMore={isFetchingNextPage}
      maxHeight={maxHeight}
      onLoadMore={fetchNextPage}
      onRowClick={handleRowClick}
      table={table}
    >
      <EnhancedDataTableToolbar>
        <EnhancedDataTableSearch placeholder="Search conversations..." />
        <EnhancedDataTableViewOptions />
      </EnhancedDataTableToolbar>
    </EnhancedDataTable>
  );
});
